<template>
  <div class="leap-year-promo" v-if="isLeapYearPromoActive">
    <div class="leap-year-promo__promotions" v-if="showPromoBundles">
      <PlanRowItem
        v-for="(plan, index) in adventuresList"
        :key="plan.id"
        :plan="plan"
        :index="index"
        class="leap-year-promo__bundle-individuals-item"
      />
    </div>
    <SmallPrints class="leap-year-promo__small-print" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { updateCart, utmParamsUtils } from '@/helpers/mixins'
import PlanRowItem from '@/components/plan-item-card/PlanRowItem.vue'
import SmallPrints from '@/components/flow/small-prints/SmallPrints.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'LeapYearView',
  mixins: [updateCart, utmParamsUtils],
  components: {
    SmallPrints,
    PlanRowItem,
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
      availableProductBundles: state => state.products.availableProductBundles,
    }),
    ...mapGetters({
      isLeapYearPromoActive: 'app/isLeapYearPromoActive',
      isBusinessUser: 'business/isBusinessUser',
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    fundamentalsAnnual() {
      const {
        PLANS: { ANNUAL },
      } = CONSTANTS
      return this.availablePlans.find(item => item.merchant_id && item.merchant_id === ANNUAL)
    },
    filteredBundles() {
      const {
        LEAP_YEAR_PROMO_PRODUCT_BUNDLES: { INE_LEAP_YEAR_BUNDLE },
      } = CONSTANTS
      return this.availableProductBundles.find(
        bundle => bundle.slug && bundle.slug === INE_LEAP_YEAR_BUNDLE
      )
    },
    adventuresList() {
      return [this.filteredBundles, this.fundamentalsAnnual]
    },
    showPromoBundles() {
      if (this.isBusinessUser) {
        return false
      }
      return !this.userHasSubscription
    },
  },
  created() {
    this.clearCart()
    if (!this.isLeapYearPromoActive) {
      this.$router.push({ name: 'shop' })
    }
  },
}
</script>
<style lang="scss" scoped>
.leap-year-promo {
  padding: 20px;
  display: flex;
  flex-flow: column;
  gap: 30px;
  @include mobile {
    margin-top: 60px;
  }
  @include desktop {
    max-width: 1120px;
    margin: auto;
    margin-top: 60px;
    gap: 60px;
  }
  &__promotions {
    display: flex;
    flex-flow: column;
    gap: 20px;
    @include mobile {
      flex-flow: row;
    }
  }
}
</style>
